/* eslint-disable no-undef */
import { useEffect, useState } from 'react';

type LocalStorageReturn<T> = [value: T, updateValue: (newValue: T) => void];

const getItem = (key: string) => {
  const itemStr = localStorage.getItem(key);

  if (typeof itemStr === 'string') {
    return JSON.parse(itemStr);
  }

  return null;
};

function useLocalStorage<T>(key: string, initialState: T): LocalStorageReturn<T> {
  const [value, setValue] = useState<T>(initialState);

  const updateValue = (newValue: T) => {
    localStorage.setItem(key, JSON.stringify(newValue));
    setValue(newValue);
  };

  useEffect(() => {
    const newValue = getItem(key);

    if (newValue !== null) {
      setValue(getItem(key));
    }
  }, []);

  return [value, updateValue];
}

export default useLocalStorage;
